define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var GridColumnModel = /** @class */ (function () {
        function GridColumnModel(data) {
            this.category = ko.observable();
            this.encoded = ko.observable();
            this.field = ko.observable();
            this.filterable = ko.observable();
            this.exportable = ko.observable();
            this.headerTemplate = ko.observable();
            this.footerTemplate = ko.observable();
            this.hidden = ko.observable();
            this.sortable = ko.observable();
            this.template = ko.observable();
            this.title = ko.observable();
            this.parentTitle = ko.observable();
            this.width = ko.observable();
            this.useTemplateValue = ko.observable(false);
            this.exportFormat = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, GridColumnModel.Mapping, self);
            }
            self.fullTitle = ko.computed(function () {
                if (self.parentTitle && self.parentTitle()) {
                    return self.parentTitle() + ' - ' + self.title();
                }
                return self.title();
            });
        }
        GridColumnModel.Mapping = {
            key: function (data) {
                return data.field;
            },
            create: function (options) {
                return new GridColumnModel(options.data);
            }
        };
        return GridColumnModel;
    }());
    return GridColumnModel;
});
//# sourceMappingURL=GridColumnModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/GridColumnModel.js
// module id = 66
// module chunks = 2